/**
 * Utilitário para sinalização visual de "OS de retorno" no Board.
 * Considera os_request_status (LCMY_REG_RETURN) ou TB02115_STATUS (ex.: ordem vinda de Em aberto).
 */

const cod = (v) => (v != null && v !== '') ? String(v).trim() : '';

/**
 * Indica se a ordem deve ser exibida como retorno nas colunas de técnicos.
 * Retorna true quando:
 * - os_request_status ou TB02115_STATUS === codstatusRetorno (config "OS de retorno"), ou
 * - os_request_status ou TB02115_STATUS esteja em extraRetornoStatuses (quando configurado em LCMY_REG_CONDITION).
 * @param {object} ordem - Ordem com os_request_status e/ou TB02115_STATUS
 * @param {string} codstatusRetorno - codstatus da configuração "OS de retorno"
 * @param {string[]} [extraRetornoStatuses] - Lista opcional de outros status de retorno
 * @returns {boolean}
 */
export function isOrderRetornoByRequestStatus(ordem, codstatusRetorno, extraRetornoStatuses = []) {
  const ref = String(codstatusRetorno || '').trim();
  const hasRef = ref !== '';

  const normalizedExtras = Array.isArray(extraRetornoStatuses) && extraRetornoStatuses.length > 0
    ? new Set(
        extraRetornoStatuses
          .filter((v) => v != null && v !== '')
          .map((v) => String(v).trim())
          .filter((v) => v !== '')
      )
    : null;

  if (!hasRef && !normalizedExtras) return false;

  const byRequest = cod(ordem?.os_request_status ?? ordem?.OS_REQUEST_STATUS);
  const byStatus = cod(ordem?.TB02115_STATUS ?? ordem?.tb02115_status);

  const matches = (value) => {
    if (!value) return false;
    if (hasRef && value === ref) return true;
    if (normalizedExtras && normalizedExtras.has(value)) return true;
    return false;
  };

  return matches(byRequest) || matches(byStatus);
}

/**
 * Indica se a OS de retorno tem pedido vinculado liberado (request_status da view LCMY_ASSTEC02 = config).
 * @param {object} ordem - Ordem com request_status (status do pedido vinculado)
 * @param {string} codstatusPedidoVinculadoDisponivel - codstatus da config "Status de pedido vinculado a OS de retorno"
 * @returns {boolean}
 */
export function isOrderPedidoLiberado(ordem, codstatusPedidoVinculadoDisponivel) {
  const ref = String(codstatusPedidoVinculadoDisponivel ?? '').trim();
  if (ref === '') return false;
  const rs = cod(ordem?.request_status ?? ordem?.REQUEST_STATUS);
  return rs === ref;
}
